// src/game/entry.ts — Uygulamanın AÇILIŞ kipi: menü mü, doğrudan eğitim mi, doğrudan ağ mı?
//
// NEDEN: derin bağlantılar (?net=1, ?tutorial=1) eskiden main.ts'te iki ayrı kod dalıydı — ?net kendi
// `for(;;)` döngüsüyle menü döngüsünün ÖNÜNDE duruyordu. Artık ikisi de "döngünün ilk turunda tüketilen
// bir tohum": tek akış, tek döngü. Saf ve DOM'suz olduğu için testte kilitlenebiliyor.
export type Entry = 'menu' | 'tutorial' | 'online';

/**
 * Açılış kipi. Öncelik: ağ > eğitim > menü.
 *
 * `has()` semantiği BİLEREK korunuyor — `?net=0` da "ağ" demektir. Bayrak parametrelerinin tamamı bu depoda
 * böyle okunuyor (?stats, ?record, ?mute); burada değeri yorumlamaya kalkmak menüyü diğerlerinden ayırırdı.
 * İkisi birden verilirse ağ kazanır: Game zaten `net && tutorial` durumunda hata fırlatıyor (eğitim sim'i
 * tick akışının dışında değiştiriyor), öncelik bunu daha ortaya çıkmadan gereksiz kılıyor.
 */
export function entryOf(params: URLSearchParams): Entry {
  if (params.has('net')) return 'online';
  if (params.has('tutorial')) return 'tutorial';
  return 'menu';
}
